import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export type GalleryKind = 'txt' | 'img' | 'vid'
const KIND_ORDER: GalleryKind[] = ['txt', 'img', 'vid']

interface State {
  handles: string[]
  kinds: GalleryKind[]
  columns: number
  fsColumns: number
  sfw: boolean
  nsfw: boolean
  addHandle: (h: string) => void
  removeHandle: (h: string) => void
  clearHandles: () => void
  toggleKind: (k: GalleryKind) => void
  setColumns: (n: number) => void
  setFsColumns: (n: number) => void
  setSfw: (b: boolean) => void
  setNsfw: (b: boolean) => void
}

const normalize = (h: string) => h.replace(/^@/, '').trim().toLowerCase()

export const useTiles = create<State>()(
  persist(
    (set, get) => ({
      handles: [],
      kinds: ['txt', 'img', 'vid'],
      columns: 4,
      fsColumns: 8,
      sfw: true,
      nsfw: true,
      addHandle: (h) => {
        const n = normalize(h)
        if (!n) return
        const cur = get().handles
        if (cur.includes(n)) return
        set({ handles: [...cur, n] })
      },
      removeHandle: (h) => {
        const n = normalize(h)
        set({ handles: get().handles.filter((x) => x !== n) })
      },
      clearHandles: () => set({ handles: [] }),
      toggleKind: (k) =>
        set(() => {
          const cur = new Set(get().kinds)
          if (cur.has(k)) cur.delete(k)
          else cur.add(k)
          return { kinds: KIND_ORDER.filter((x) => cur.has(x)) }
        }),
      setColumns: (n) =>
        set({ columns: Math.max(2, Math.min(12, Math.round(n))) }),
      setFsColumns: (n) =>
        set({ fsColumns: Math.max(3, Math.min(20, Math.round(n))) }),
      setSfw: (b) => set({ sfw: b }),
      setNsfw: (b) => set({ nsfw: b }),
    }),
    { name: 'skypanel:tiles', version: 1 },
  ),
)
